export const questions = [
  // Masai email
  {
    name: "email",
    title: "Enter your COURSE Platform email given by Masai School",
    type: "input",
    placeholder: "type email here and press enter...",
  },
  {
    name: "password",
    title: "Enter OTP sent to your email:",
    type: "input",
    placeholder: "type otp here and press enter...",
  },
  // Personal email
  // {
  //   name: "personal_email",
  //   title: "Please enter your PERSONAL email",
  //   type: "input",
  //   placeholder: "type email here and press enter...",
  // },
  // {
  //   name: "personal_password",
  //   title: "Enter OTP sent to your PERSONAL email",
  //   type: "input",
  //   placeholder: "type otp here and press enter...",
  // },
  // Parent email
  {
    name: "parent_email",
    title: "Enter your PARENT's email",
    type: "input",
    placeholder: "type email here and press enter...",
  },
  {
    name: "parent_password",
    title: "Enter OTP sent to your PARENT's email",
    type: "input",
    placeholder: "type otp here and press enter...",
  },
  // basic info
  {
    name: "name",
    title: "Please enter your name as per your aadhaar id ?",
    type: "input",
    placeholder: "type name here...",
  },
  {
    name: "parent_name",
    title: "Please enter your parent name ?",
    type: "input",
    placeholder: "type parent name here...",
  },
  {
    name: "student_phone",
    title: "Please enter your 10 digit mobile number ?",
    type: "input",
    placeholder: "type your mobile number here...",
    maxLength: 10,
  },
  {
    name: "self_filled_student_code",
    title:
      "Please enter your student code given by Masai School ? eg: fw15_123",
    type: "input",
    placeholder: "type student code here...",
  },
  {
    name: "date_of_birth",
    title: "Please select your date of birth as per your aadhaar id ?",
    type: "date",
  },
  {
    name: "message",
    title: "Hooray! It's done.",
    type: "info-success",
  },
];
